import React from 'react';

interface HorizontalPlotsProps {
  items: {
    visible: boolean;
    message: string;
    color: string;
    id: number; // Updated id property to be a number
    date: string;
  }[];
  shape?: 'hexagon' | 'triangle'; // Supports 'hexagon' and 'triangle' as the shapes for the plots
  onShapeClick?: (id: number,date:string) => void; // Callback function to handle shape clicks
}

const HorizontalPlots: React.FC<HorizontalPlotsProps> = ({ items, shape = 'hexagon', onShapeClick }) => {
  const itemWidth = 30; // Width of each shape
  const itemHeight = 26; // Height of each shape

  return (
    <div style={{ display: 'flex', alignItems: 'center', position: 'relative', backgroundColor: '#f5f7fa', padding: '10px' }}>
      {items.map((item, index) => {
        if (!item.visible) return null;

        const offset = index * (itemWidth * 0.5); // Overlapping offset up to 50%

        return (
          <div
            key={item.id}
            style={{
              position: 'absolute',
              left: `${offset}px`,
              width: itemWidth,
              height: itemHeight,
              cursor: 'pointer',
            }}
            title={item.message} // Show the message on hover
            onClick={() => onShapeClick && onShapeClick(item.id,item.date)} // Trigger callback on click
            tabIndex={0} // Enable keyboard focus
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                 if (onShapeClick) { onShapeClick(item.id,item.date)};
                }
              }
            } // Trigger callback on Enter or Space key press
              role="button"
          >
            {shape === 'hexagon' && (
              <svg width={itemWidth} height={itemHeight} viewBox={`0 0 ${itemWidth} ${itemHeight}`} xmlns="http://www.w3.org/2000/svg">
                <polygon
                  points={`
                    ${itemWidth / 2},0
                    ${itemWidth},${itemHeight / 4}
                    ${itemWidth},${(3 * itemHeight) / 4}
                    ${itemWidth / 2},${itemHeight}
                    0,${(3 * itemHeight) / 4}
                    0,${itemHeight / 4}`}
                  fill={item.color}
                />
              </svg>
            )}
            {shape === 'triangle' && (
              <svg width={itemWidth} height={itemHeight} viewBox={`0 0 ${itemWidth} ${itemHeight}`} xmlns="http://www.w3.org/2000/svg">
                <polygon
                  points={`
                    ${itemWidth / 2},0
                    ${itemWidth},${itemHeight}
                    0,${itemHeight}`}
                  fill={item.color}
                />
              </svg>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default HorizontalPlots;